module.exports = __webpack_public_path__ + "static/media/patient-history-3.8213f586.pdf";